import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { toApiError } from '../utils';

export interface ExportPropertiesParams {
	format: 'pdf' | 'xlsx';
	filter?: string;
	state?: string | string[];
	sortAsc?: boolean;
}

export function useExportProperties() {
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async ({ format, filter, state, sortAsc }: ExportPropertiesParams) => {
			try {
				const params = new URLSearchParams();
				params.set('format', format);
				if (forBinding) params.set('forBinding', forBinding);
				if (filter) params.set('filter', filter);
				if (sortAsc !== undefined) params.set('sortAsc', String(sortAsc));
				const states = Array.isArray(state) ? state : state ? [state] : [];
				states.forEach((uf) => params.append('state', uf));

				const response = await api.get<Blob>('/user/prop/export', {
					params,
					responseType: 'blob',
				});
				const disposition = response.headers['content-disposition'] as string | undefined;
				const filename = disposition?.match(/filename="?([^";]+)"?/i)?.[1];
				return { file: response.data, filename: filename ?? `propriedades.${format}` };
			} catch (error) {
				throw toApiError(error, 'Erro ao exportar propriedades');
			}
		},
	});
}
